"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializerManagerV2 = void 0;
class InitializerManagerV2 {
    constructor(initializers) {
        this.getInitializersKeys = () => {
            return Object.keys(this.initializers);
        };
        this.getNotInitializedKeys = () => {
            return this.getInitializersKeys().filter(id => {
                return !this.initializers[id].isInitialized;
            });
        };
        this.getInitializersKeysWithResolvedDependencies = (initializersKeys) => {
            return initializersKeys.filter(id => {
                const initializer = this.initializers[id];
                return (!initializer.dependencies.length ||
                    (initializer.dependencies.map(dependency => dependency.isInitialized).every(Boolean) && !initializer.isInitialized));
            });
        };
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            const notInitializedKeys = this.getNotInitializedKeys();
            const keysToInitialize = this.getInitializersKeysWithResolvedDependencies(notInitializedKeys);
            yield Promise.all(keysToInitialize.map(id => {
                const initializer = this.initializers[id];
                return Promise.resolve(initializer.init()).then(initialized => {
                    initializer.setInitialized(initialized);
                });
            }));
            if (this.getNotInitializedKeys().length) {
                yield this.init();
            }
            return this.getInitializersKeys().reduce((acc, curr) => {
                const t = this.initializers[curr].getInitialized();
                return Object.assign(Object.assign({}, acc), { [curr]: t });
            }, {});
        });
        this.initializers = initializers;
    }
}
exports.InitializerManagerV2 = InitializerManagerV2;
//# sourceMappingURL=initializerManager.js.map